/* eslint-disable no-prototype-builtins */
import {AssetType, DetectionType} from '@taopix/taopix-core';
import {AssetMetaInterface} from '@taopix/taopix-core/dist/types/types';

const isPageStyle = (payload: any): boolean => {
  return payload.hasOwnProperty('emptypictureboxcount');
};

const isAsset = (payload: any): boolean => {
  return payload.hasOwnProperty('assetRef');
};

const isUserAsset = (payload: any): boolean => {
  return payload.hasOwnProperty('assetType') && AssetType.User === payload.assetType;
};

const getDetectionTypeFromAsset = (payload: AssetMetaInterface) => {
  if (!isAsset(payload)) {
    return DetectionType.None;
  }

  switch (payload.assetType) {
    case AssetType.Background:
      return DetectionType.Background;
    case AssetType.Mask:
      return DetectionType.Mask;
    case AssetType.ScrapbookImage:
      return DetectionType.ScrapBookImage;
    case AssetType.ScrapbookClipping:
      return DetectionType.ScrapbookClipping;
    default:
      return DetectionType.None;
  }
};

export const getDetectionType = (payload: any) => {
  if (isUserAsset(payload)) {
    return {
      detectionType: DetectionType.User,
      pageStyleType: null,
      assetType: payload.assetType,
    };
  }

  // backgrounds, masks, scrapbooks
  if (isAsset(payload)) {
    return {
      detectionType: getDetectionTypeFromAsset(payload),
      pageStyleType: null,
      assetType: payload.assetType,
    };
  }

  // page styles
  if (isPageStyle(payload)) {
    return {
      detectionType: DetectionType.PageStyle,
      pageStyleType: payload.type,
      assetType: null,
    };
  }

  return {
    detectionType: DetectionType.None,
    pageStyleType: null,
    assetType: null,
  };
};
